// import React from "react";
import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { BookNowProps } from "./types";
import {
    PropertyDefinition
} from "app/library/layout-builder";

export class BookNowDefinitions extends CmsReactComponent<BookNowProps> {

    static schemaName = "book-now";

    static propertyDefinitions: PropertyDefinition[] = [];

}
